import { gql } from '@apollo/client';

export const AnyEventFieldsFragment = gql`
  fragment AnyEventFields on AnyEvent {
    kind
    name
  }
`;

export const AnyTableEventFieldsFragment = gql`
  fragment AnyTableEventFields on AnyTableEvent {
    kind
    name
    key
  }
`;
